"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.range = void 0;

var range = function range(start, stop, step) {
  return Array.from({
    length: (stop - start) / step + 1
  }, function (_, i) {
    return start + i * step;
  });
};

exports.range = range;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/util/index.js
// module id = 1940
// module chunks = 0